/* eslint-disable lines-between-class-members */
/* eslint-disable react/sort-comp */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unused-prop-types */
// Copyright (c) 2021 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import classnames from 'classnames'
import CustomMapDrawPanelFactory from 'components/CustomKepler/map/CustomMapDrawPanel'
import { toggleModal } from 'kepler.gl/actions'
import { MapControlFactory, MapControlPanelFactory } from 'kepler.gl/components'
import { Docs, Layers } from 'kepler.gl/dist/components/common/icons'
import MapLayerSelector from 'kepler.gl/dist/components/common/map-layer-selector'
import { MapControlButton, Tooltip } from 'kepler.gl/dist/components/common/styled-components'
// import ToolbarItem from 'kepler.gl/dist/components/common/toolbar-item'
// import VerticalToolbar from 'kepler.gl/dist/components/common/vertical-toolbar'
// eslint-disable-next-line absolute-import/no-relative-path
import React from 'react'
import { connect, useDispatch } from 'react-redux'
import styled from 'styled-components'
import { FormattedMessage } from 'translations/index'
// import { LOCALE_CODES } from 'translations/locales'

const StyledMapControl = styled.div`
  right: 0;
  top: 84px;
  padding: ${(props) => props.theme.mapControl.padding + 3}px;
  z-index: 10;
  // margin-top: ${(props) => props.top || 0}px;
  position: absolute;
  display: grid;
  row-gap: 8px;
  justify-items: end;
  pointer-events: none; /* prevent padding from blocking input */
  & > * {
    /* all children should allow input */
    pointer-events: all;
  }
`

/** @type {import('./map-control').MapControlTooltipComponent} */
const MapControlTooltip = React.memo(({ id, message }) => (
  <Tooltip id={id} place='left' effect='solid'>
    <span>
      <FormattedMessage id={message} />
    </span>
  </Tooltip>
))

MapControlTooltip.displayName = 'MapControlTooltip'

/**
 *
 * EXTRA CUSTOM BUTTON - THIS ONE WAS FOR USER'S SAVED MAPS
 *
 * */
const StyledProjectPanel = styled.div`
  background: ${(props) => props.theme.panelBackground};
  padding: 10px;
  width: 280px;
  box-shadow: ${(props) => props.theme.panelBoxShadow};
  .project-title {
    color: ${(props) => props.theme.titleTextColor};
    font-size: 13px;
    font-weight: 500;
    display: flex;
    justify-content: space-between;
  }
  .project-description {
    color: ${(props) => props.theme.textColor};
    font-size: 11px;
    margin-top: 12px;
    a {
      font-weight: 500;
      color: ${(props) => props.theme.titleTextColor};
    }
  }
  .project-links {
    margin-top: 20px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
`

const SampleMapPanel = React.memo((props) => {
  const [isActive, setActive] = React.useState(props.publicUser)

  // Redux Selector

  return (
    <>
      {props.code !== null && props.session.title !== '' && props.session.title !== null ? (
        <>
          {isActive ? (
            <StyledProjectPanel>
              <div className='project-title'>
                <div>{props.session.title}</div>
                <div onClick={() => setActive(false)} className='cursor-pointer w-3 h-3'>
                  <svg
                    viewBox='0 0 24 24'
                    strokeWidth='2'
                    stroke='currentColor'
                    fill='none'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  >
                    <path stroke='none' d='M0 0h24v24H0z' fill='none' />
                    <line x1='18' y1='6' x2='6' y2='18' />
                    <line x1='6' y1='6' x2='18' y2='18' />
                  </svg>
                </div>
              </div>

              {props.session.description && <div className='project-description'>{props.session.description}</div>}
            </StyledProjectPanel>
          ) : (
            <MapControlButton
              onClick={(e) => {
                e.preventDefault()

                setActive(true)
              }}
            >
              <Docs height='18px' />
            </MapControlButton>
          )}
        </>
      ) : null}
    </>
  )
})
const UserMapsLoaderPanel = React.memo(({ onToggleMapControl, mapControls }) => {
  const dispach = useDispatch()
  const showSavedMap = mapControls?.showSavedMap || {}
  const { active: isActive } = showSavedMap || {}

  const onToggleMenuPanel = React.useCallback(
    (event) => {
      event.preventDefault()
      onToggleMapControl('showSavedMap')
      dispach(toggleModal('USER_SAVED_MAPS'))
    },
    [onToggleMapControl],
  )

  return (
    <MapControlButton
      key='user-maps-loader'
      onClick={onToggleMenuPanel}
      className={classnames('map-control-button', 'user-maps-loader', { isActive })}
      data-tip
      data-for='user-maps-loader'
    >
      {/* <MapIcon height='22px' /> */}
      <MapControlTooltip
        id='user-maps-loader'
        message={isActive ? 'toolbar.hideUserMapsLoader' : 'toolbar.showUserMapsLoader'}
      />
    </MapControlButton>
  )
})

UserMapsLoaderPanel.displayName = 'UserMapsLoaderPanel'

/** @type {import('./map-control').LayerSelectorPanelComponent} */
const LayerSelectorPanel = React.memo(
  ({ onMapToggleLayer, onToggleMapControl, layers, layersToRender, isSplit, mapControls, readOnly, ...restProps }) => {
    const visibleLayers = mapControls?.visibleLayers || {}
    const { active: isActive, disableClose } = visibleLayers || {}

    const legendLayers = React.useMemo(
      () =>
        layers.map(({ id, config }) => ({
          id,
          name: config.label,
          // layer
          isVisible: layersToRender[id],
        })),
      [layers, layersToRender],
    )

    const onToggleMenuPanel = React.useCallback(
      (event) => {
        event.preventDefault()
        onToggleMapControl('visibleLayers')
      },
      [onToggleMapControl],
    )

    return !isActive ? (
      <MapControlButton
        key={1}
        onClick={onToggleMenuPanel}
        className={classnames('map-control-button', 'toggle-layer', { isActive })}
        data-tip
        data-for='toggle-layer'
      >
        <Layers height='22px' />
        <MapControlTooltip id='toggle-layer' message={isActive ? 'tooltip.hideLayerPanel' : 'tooltip.showLayerPanel'} />
      </MapControlButton>
    ) : (
      <CustomMapControlPanel header='header.visibleLayers' onClick={onToggleMenuPanel} disableClose={disableClose}>
        <MapLayerSelector layers={legendLayers} onMapToggleLayer={onMapToggleLayer} />
      </CustomMapControlPanel>
    )
  },
)

LayerSelectorPanel.displayName = 'LayerSelectorPanel'

const CustomMapControlPanel = React.memo(MapControlPanelFactory())

// const StyledToolbar = styled(VerticalToolbar)`
//   position: absolute;
//   right: 32px;
// `

// /** @type {import('./map-control').LocalePanelComponent} */
// const LocalePanel = React.memo(
//   ({ availableLocales, onToggleMapControl, onSetLocale, locale: currentLocal, mapControls }) => {
//     const { active: isActive, disableClose, show } = mapControls.mapLocale || {}

//     const onClickItem = React.useCallback(
//       (locale) => {
//         onSetLocale(locale)
//         onToggleMapControl('mapLocale')
//       },
//       [onSetLocale],
//     )

//     const onClickButton = React.useCallback(
//       (e) => {
//         e.preventDefault()
//         onToggleMapControl('mapLocale')
//       },
//       [onToggleMapControl],
//     )
//     const getLabel = React.useCallback((locale) => `toolbar.${locale}`, [])

//     if (!show) {
//       return null
//     }

//     return (
//       <div style={{ position: 'relative' }}>
//         {isActive ? (
//           <StyledToolbar show={isActive}>
//             {/* Use our LOCALE_CODES instead of default 'availableLocales' */}
//             {Object.keys(LOCALE_CODES).map((locale) => (
//               <ToolbarItem
//                 key={locale}
//                 onClick={() => onClickItem(locale)}
//                 label={getLabel(locale)}
//                 active={currentLocal === locale}
//               />
//             ))}
//           </StyledToolbar>
//         ) : null}
//         <MapControlButton
//           onClick={onClickButton}
//           className={classnames('map-control-button', 'map-locale', { isActive })}
//           active={isActive}
//           data-tip
//           data-for='locale'
//           disableClose={disableClose}
//         >
//           <span className='map-control-button__locale'>{currentLocal.toUpperCase()}</span>
//           <MapControlTooltip id='locale' message='tooltip.selectLocale' />
//         </MapControlButton>
//       </div>
//     )
//   },
// )

// LocalePanel.displayName = 'LocalePanel'

// const SampleMapPanel = React.memo(() => {
//   return (
//     <MapControlButton
//       onClick={(e) => {
//         e.preventDefault()
//       }}
//     >
//       <Docs height='18px' />
//     </MapControlButton>
//   )
// })

const mapControlDeps = [...MapControlFactory.deps]
mapControlDeps[0] = CustomMapDrawPanelFactory
CustomMapControlFactory.deps = mapControlDeps

function CustomMapControlFactory(MapDrawPanel, Toggle3dButton, SplitMapButton, MapLegendPanel) {
  const DEFAULT_ACTIONS = [
    SampleMapPanel,
    SplitMapButton,
    LayerSelectorPanel,
    Toggle3dButton,
    MapLegendPanel,
    MapDrawPanel,
    // LocalePanel,
  ]

  /** @type {import('./map-control').MapControl} */
  const MapControl = ({ actionComponents = DEFAULT_ACTIONS, ...props }) => {
    return (
      <StyledMapControl className='map-control' top={props.top}>
        {actionComponents.map((ActionComponent, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <ActionComponent key={index} className='map-control-action' {...props} />
        ))}
      </StyledMapControl>
    )
  }

  MapControl.defaultProps = {
    isSplit: false,
    top: 0,
    mapIndex: 0,
    logoComponent: <></>,
  }

  MapControl.displayName = 'MapControl'

  const mapStateToProps = (state) => ({
    user: state.app.user.user,
    session: state.app.view.session,
    code: state.app.view.code,
  })
  const mapDispatchToProps = (dispatch) => ({})

  return connect(mapStateToProps, mapDispatchToProps)(MapControl)
}

export function replaceMapControl() {
  return [MapControlFactory, CustomMapControlFactory]
}
